import React, { useState, useRef, useEffect } from "react";
import "./AddNoteGroup.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { colorOptions, normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";
import { useTranslation } from "react-i18next";

function AddNoteGroup({ createNoteGroup, cancelCreateNoteGroup }) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [selectedColor, setSelectedColor] = useState(colorOptions[0]);
  const [showNameError, setShowNameError] = useState(false);

  const handleCreateNoteGroup = () => {
    if (name.trim()) {
      const colorHex = normalizeColor(selectedColor);
      createNoteGroup(name.trim(), colorHex);
      setName("");
      setSelectedColor(colorOptions[0]);
      setShowNameError(false);
    } else {
      setShowNameError(true);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100); // 100ms delay to ensure DOM is ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="add-note-group-content">
      <div className="modal-title">
        <div>{t("notes.modals.addGroup.title")}</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">{t("common.name")}</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder={t("notes.modals.addGroup.namePlaceholder")}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (showNameError && e.target.value.trim()) {
              setShowNameError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleCreateNoteGroup();
            }
          }}
        />
        {showNameError && (
          <div className="modal-helper-text">
            {t("notes.modals.nameRequired")}
          </div>
        )}

        <div className="modal-form-title">{t("common.color")}</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>

        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              setName("");
              setSelectedColor(colorOptions[0]);
              setShowNameError(false);
              cancelCreateNoteGroup();
            }}
          >
            {t("common.cancel")}
          </button>
          <button className="modal-button save" onClick={handleCreateNoteGroup}>
            {t("common.create")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNoteGroup;
